// Laadt het Pinterest-bord pas wanneer dat mag.
//
// De widget van Pinterest (pinit.js) plaatst cookies en praat met hun servers.
// Onder de AVG mag dat niet voordat de bezoeker toestemming heeft gegeven, en
// deze winkel heeft een toestemmingsbalk. Daarom blijft het bordvak standaard
// verborgen; de eigen foto's eronder staan er altijd. Niemand ziet dus een
// leeg gat.
//
// Zodra er toestemming is - meteen bij het laden, of later als de bezoeker op
// Accepteren klikt - verschijnt het bord boven de eigen foto's (sinds 1 okt
// 2026 vervangt het ze niet meer). In de thema-instellingen kan dat wachten
// worden overgeslagen; die keuze is aan de winkelier, niet aan dit script.
(function () {
  'use strict';

  var vak = document.querySelector('[data-insp-pin]');
  if (!vak) return;
  var geladen = false;

  function toonBord() {
    if (geladen) return;
    geladen = true;
    vak.hidden = false;

    var s = document.createElement('script');
    s.src = 'https://assets.pinterest.com/js/pinit.js';
    s.async = true;
    s.defer = true;
    // Lukt het laden niet - een blokkerende extensie, geen netwerk - dan gaat
    // het vak weer dicht. Beter dan een lege kop boven de eigen foto's.
    s.onerror = function () {
      vak.hidden = true;
    };
    document.head.appendChild(s);
  }

  if (vak.getAttribute('data-altijd') === '1') {
    toonBord();
    return;
  }

  function magHet() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p) return null;
    try {
      // Pinterest valt onder marketing; sommige winkels zetten alleen analytics
      // aan. Allebei goedgekeurd is het duidelijkst.
      return p.marketingAllowed() && p.analyticsProcessingAllowed();
    } catch (e) {
      return null;
    }
  }

  function kijk() {
    if (magHet() === true) toonBord();
  }

  // De toestemmings-API van Shopify wordt apart ingeladen.
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (fout) {
        if (!fout) kijk();
      }
    );
  } else {
    kijk();
  }

  // En nog een keer zodra de bezoeker zijn keuze maakt.
  document.addEventListener('visitorConsentCollected', kijk);
})();
